<template>
    <div class="main" v-if="!loading">
        
        <el-form @submit.native.prevent="onSubmit" label-position="top">

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Instituição</label>
                    <el-select v-model="instituicao" filterable @change="selectIntituicao()">
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            
            <template v-if="instituicao">

                <div class="u-mb-20" style="display: flex; align-items: center;">
                    <h3 class="u-mb-5">Lançamento de notas</h3>
                    <i style="margin-top: 10px; margin-left: 5px;">- Períodos disponíveis para lançamento de notas.</i>
                </div>

                <el-checkbox-group v-model="dados" class="checkbox-filtos">
                    <template v-for="(item, i) in periodos" >
                        <el-checkbox :label="i">{{ item }}</el-checkbox>
                    </template>
                </el-checkbox-group>
                
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </template>
            <template v-else>
                <div class="u-text-center u-mt-50">
                    <i>Selecione uma instituição.</i>
                </div>
            </template>

            
            

        </el-form>
    </div>
</template>
<script>

export default {
    data () {
        return {
            instituicao: '',
            loading: false,
            periodos:[],
            dados: []
        }
    },
    methods:{
        selectIntituicao() {
            if(this.instituicao) {
                this.initFormParametros();
            }
        },
        async initFormParametros(){

            this.loading = true;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/initFormParametros/${this.instituicao}`, this.$store.getters.getHeaderAuth);
            
            this.periodos = JSON.parse(JSON.stringify(response.data.options));

            this.dados = JSON.parse(JSON.stringify(response.data.dados));
                    
            this.loading = false;
        },        
        async onSubmit (){

            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeParamAcoesNotas/${this.instituicao}`, this.dados, this.$store.getters.getHeaderAuth);

            if(typeof response.data.error !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

            }else{

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.initFormParametros();
            }

        },
    }    
}
</script>